import React, { useEffect, useState, useRef } from 'react';
import { Container, Typography, Button, IconButton, Box, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams } from 'react-router-dom'; // For navigation (if you're using react-router-dom)
import { useApi } from './api'; // Adjust the import path as needed
import {useLocation} from 'react-router-dom';

const Description = ({desc}) => {
  if (Array.isArray(desc)) {
    return desc.map((de, ind) => (<Typography sx={{mb:1}} key={`desc-${ind}`}>&emsp;{de}</Typography>))
  }
  return (<Typography> {desc}</Typography>)
}

const Persons = ({persons}) => {
  if (Array.isArray(persons) && persons.length > 0) {
    return (
      <Stack direction="row" sx={{mb:1}}>
        {persons.map((person, i) => {
          let lbl = person
          if (person.trim().toLowerCase() === "amma") {
            lbl = "Ummu Salma"
          }
          if (person.trim().toLowerCase() === "aliyamma") {
            lbl = "Aliya"
          }
          if (i !== persons.length -1) {
            lbl += `  ↔️`
          }
          return (<Typography sx={{mr: 1, fontSize: "12px"}}>{lbl}</Typography>)
        }
        )}
      </Stack>
    )
  }
}

const Detail = () => {
    const [item, setItem] = useState()
    const navigate = useNavigate(); // For back button navigation
    const { id } = useParams();
    const { get } = useApi()
    const mediaRef = useRef(null);
    const [currentSpeed, setCurrentSpeed] = useState(1);
    const location = useLocation();

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };
  
  console.log(location.state)
  const getData = async (id) => {
    const data = await get(`/clip/${id}`)
    setItem(data);
  }

  useEffect(()=>{
    getData(id)
  }, [id])

  const setPlaybackSpeed = (speed) => {
    if (mediaRef.current) {
      mediaRef.current.playbackRate = speed;
      setCurrentSpeed(speed);
    }
  };

  const skipTime = (time) => {
    if (mediaRef.current) {
      mediaRef.current.currentTime += time;
    }
  };


if (item) {
  return (
    <Container>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <IconButton onClick={handleBackClick} aria-label="back">
          <ArrowBackIcon />
        </IconButton>
      </Box>

      <Box sx={{ mb: 2 }}>
        {item?.type === 'video' ? (
          <video width="100%" controls ref={mediaRef} controlsList="nodownload">
            <source src={item?.file} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <audio ref={mediaRef} width="100%" style={{"width": "100%"}} controls controlsList="nodownload">
            <source src={item?.file} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
        )}
        <Stack direction="row" sx={{ width: '100%', mt: 2}} alignItems="center" justifyContent="space-around">
          <Button onClick={() => skipTime(-10)}>⏪ 10s</Button>
          <Button onClick={() => setPlaybackSpeed(1)} sx={{ border: currentSpeed === 1 ? '1px solid black' : 'none' }}>▶️</Button>
          <Button onClick={() => setPlaybackSpeed(1.5)} sx={{ border: currentSpeed === 1.5 ? '1px solid black' : 'none'  }}>▶️▶️</Button>
          <Button onClick={() => setPlaybackSpeed(1.7)} sx={{ border: currentSpeed === 1.7 ? '1px solid black' : 'none'  }}>▶️▶️▶️</Button>
          <Button onClick={() => skipTime(10)}>⏩ 10s</Button>
        </Stack>
      </Box>
      <Stack direction="column" sx={{mb: 2}}>
        <Typography variant="h6" sx={{ fontWeight: 'bold'  }}>
         {`${item.sl_no}. ${item.title}`}
        </Typography>
        <Stack>
          {item.formatted_origial_duration && (<Typography variant="caption" sx={{mb: 1}}>
            Orignal Length : {item.formatted_origial_duration}
          </Typography>)}
          <Persons persons={item.person}/>
        </Stack>
        {item?.date && (<Typography variant="caption">
          {item.date}
        </Typography>)}
      </Stack>
      <Box>
        <Description desc={item.desc}/>
        </Box>
    </Container>
  );
    }
    return null
}

export default Detail